import { render, staticRenderFns } from "./AltChat.vue?vue&type=template&id=c21ef376&"
import script from "./AltChat.vue?vue&type=script&lang=js&"
export * from "./AltChat.vue?vue&type=script&lang=js&"
import style0 from "./AltChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports